import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ImageUploader from './components/ImageUploader';
import ValidationResults from './components/ValidationResults';
import Header from './components/Header';
import Footer from './components/Footer';
import PhotoInstructions from './components/PhotoInstructions';
import AdminPanel from './components/AdminPanel';
import ReviewImages from './components/ReviewImages';

function MainApp() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isAdminImagesPage = location.pathname === '/admin/images';
  const [validationResults, setValidationResults] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fixMode, setFixMode] = useState(false);
  const [rejectedImages, setRejectedImages] = useState([]);
  const [acceptedImages, setAcceptedImages] = useState([]);
  

  const handleValidationComplete = (results) => {
    setValidationResults(results);
    setIsLoading(false);
    setError(null);
  };

  const handleValidationStart = () => {
    setIsLoading(true);
    setError(null);
    setValidationResults(null);
  };

  const handleValidationError = (error) => {
    setError(error);
    setIsLoading(false);
    setValidationResults(null);
  };

  const handleReset = () => {
    setValidationResults(null);
    setError(null);
    setIsLoading(false);
    setFixMode(false);
    setRejectedImages([]);
    setAcceptedImages([]);
  };

  const handleFixRejected = (rejectedImgs) => {
    setFixMode(true);
    setRejectedImages(rejectedImgs);
    setAcceptedImages(validationResults.results.filter(result => result.decision === 'accept'));
    setValidationResults(null);
    setError(null);
    setIsLoading(false);
  };

  const handleAddOpinion = () => {
    // Trigger the same validation process again to save opinion to Airtable
    if (validationResults) {
      setIsLoading(true);
      setError(null);
      
      // Simulate the same process but this time it will save to Airtable
      setTimeout(() => {
        // The backend will handle saving to Airtable
        setValidationResults({
          ...validationResults,
          reviewId: 'temp-review-id', // This will be replaced by real ID from backend
          discountCode: validationResults.discountCode || 'UGC-TEMP-CODE'
        });
        setIsLoading(false);
      }, 2000);
    }
  };

  if (isAdminPage) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <AdminPanel />
        <Footer />
      </div>
    );
  }

  if (isAdminImagesPage) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <ReviewImages />
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="container mx-auto px-4 py-4">
        <div className="max-w-4xl mx-auto">
          {/* Hero Section - Only show before validation */}
          {!validationResults && (
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                Dodaj zdjęcie i odbierz kupon 100zł na zakupy !
              </h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Zweryfikuj zamówienie, wgraj minimum 3 zdjęcia oraz napisz swoją opinię.
                <br />
                Po akceptacji zdjęć otrzymasz kupon o wartości 100 zł.
              </p>
            </div>
          )}

          {/* Upload Section */}
          {!validationResults && (
            <div className="mb-8">
              <ImageUploader
                onValidationStart={handleValidationStart}
                onValidationComplete={handleValidationComplete}
                onValidationError={handleValidationError}
                isLoading={isLoading}
                fixMode={fixMode}
                rejectedImages={rejectedImages}
                acceptedImages={acceptedImages}
                validationError={error}
              />
            </div>
          )}

          {/* Results Section */}
          {validationResults && (
            <div className="mb-4">
              <ValidationResults 
                results={validationResults} 
                onReset={handleReset}
                onAddOpinion={handleAddOpinion}
                onFixRejected={handleFixRejected}
              />
            </div>
          )}



        </div>
      </main>

      {!validationResults && <PhotoInstructions />}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<MainApp />} />
        <Route path="/admin/images" element={<MainApp />} />
        <Route path="*" element={<MainApp />} />
      </Routes>
    </Router>
  );
}

export default App;

